import {
  ScheduledLessonsWeekFilters,
  listScheduledLessonsWeek,
} from '@/utils/listScheduledLessonsWeek';
import {
  getNextLesson,
  listScheduledLessons,
  ScheduledLessonFilters,
} from '../services/scheduledLessonsServices';

export const scheduledLessonQueries = {
  all: ['scheduledLessons'] as const,
  list: (filters: ScheduledLessonFilters = {}) => ({
    queryKey: [...scheduledLessonQueries.all, 'list', { filters }] as const,
    queryFn: () => listScheduledLessons(filters),
  }),
  next: (klassId: number) => ({
    queryKey: [...scheduledLessonQueries.all, 'next', klassId] as const,
    queryFn: () => getNextLesson(klassId),
  }),
  weekCalendar: (filters: ScheduledLessonsWeekFilters) => ({
    queryKey: [
      ...scheduledLessonQueries.all,
      'weekCalendar',
      { filters },
    ] as const,
    queryFn: ({ pageParam = 1 }: { pageParam?: number }) =>
      listScheduledLessonsWeek({ ...filters, pageNumber: pageParam }),
  }),
};
